export default __webpack_public_path__ + "static/media/barra.6f166657.png";